import { type Legend, type Catalog } from '@/api/queryCatalog';
import { Col, Row } from 'antd';
import styles from './index.module.less';
import { useRequest } from 'ahooks';
import { queryFileInfoApi } from '@/api/queryFileInfo';
import { useState } from 'react';
import emptyImg from './assets/loading.svg';

const ImagePreview = (props: Legend & { onSelect: (data: Legend) => void }) => {
  const [src, setSrc] = useState<string>(emptyImg);
  useRequest(
    async () => {
      if (!props.legendSvgFileId) return;
      const res = await queryFileInfoApi({
        splicingFileIds: props.legendSvgFileId
      });
      if (res.code === 200 && res.data.length) {
        setSrc(res.data[0].filePath);
      }
    },
    { manual: false }
  );
  return (
    <div className={styles['legend-item']} onClick={() => props.onSelect(props)}>
      <div className={styles['legend-item-img-box']}>
        <div className={styles['legend-item-img-box-content']}>
          <img src={src} />
        </div>
      </div>
      <div
        className={styles['legend-item-name']}
      >{`${props.legendCode}（${props.legendName}）`}</div>
    </div>
  );
};
type LegendListProps = {
  data: Catalog;
  onOpenLegendDetail: (data: Legend) => void;
  showCatalog: boolean;
};
const LegendList = (props: LegendListProps) => {
  return (
    <div style={{ width: '100%', padding: '8px', height: '100%', overflow: 'scroll' }}>
      {!!props.data.legendList?.length ? (
        <Row gutter={props.showCatalog ? [24, 24] : [16, 16]}>
          {props.data.legendList.map(legend => (
            <Col span={props.showCatalog ? 8 : 6} key={legend.legendCode}>
              <ImagePreview {...legend} onSelect={props.onOpenLegendDetail} />
            </Col>
          ))}
        </Row>
      ) : (
        <div className={styles['empty-center']}>
          <img className={styles['empty-image']} src={emptyImg} alt='empty' />
          <p className={styles['empty-text']}>暂无数据</p>
        </div>
      )}
    </div>
  );
};

export default LegendList;
